import { render, staticRenderFns } from "./SuperuserNavbar.vue?vue&type=template&id=f7688fb4&"
import script from "./SuperuserNavbar.vue?vue&type=script&lang=js&"
export * from "./SuperuserNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports